import SingleCard from "./SingleCard";
export default SingleCard;
